import type { ReactNode } from 'react';
import { palette } from './palette';
import { Pill } from './Pill';
import type { Tone } from './palette';

export function StatCard({
  label,
  value,
  icon,
  progress,
  delta,
  deltaTone = 'good',
  sub,
}: {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  progress?: number | null;
  delta?: ReactNode;
  deltaTone?: Tone;
  sub?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-border bg-surface p-[18px] shadow-shell">
      <div className="flex items-center justify-between">
        <div className="text-[10px] font-bold tracking-[0.16em] text-muted">{label}</div>
        {icon && <div style={{ color: palette.faint }}>{icon}</div>}
      </div>
      <div className="text-[30px] font-extrabold leading-none tracking-tight tabular-nums">
        {value}
      </div>
      {progress != null && (
        <div className="h-1 overflow-hidden rounded-sm" style={{ background: palette.bgAlt }}>
          <div
            className="h-full"
            style={{
              width: `${Math.min(100, progress * 100)}%`,
              background: palette.good,
            }}
          />
        </div>
      )}
      {(delta || sub) && (
        <div className="flex items-center gap-2 text-[11px] text-muted">
          {delta && <Pill tone={deltaTone}>{delta}</Pill>}
          {sub && <span className="flex-1 truncate">{sub}</span>}
        </div>
      )}
    </div>
  );
}
